'use client';

import { useEffect, useState } from 'react';
import GlobalLoader from '@/components/GlobalLoader';

export default function ClientLayout({ children }) {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    // Load Bootstrap JS safely on client
    import('bootstrap/dist/js/bootstrap.bundle.min.js');

    const timeout = setTimeout(() => {
      setShowLoader(false);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      {showLoader && <GlobalLoader />}
      {children}
    </>
  );
}